var InFlight = InFlight || {};

var interval;

InFlight.endTimerInterval = function() {
  if(interval) {
    clearInterval(interval);
  }
}


InFlight.EventTimer = function(eventTimerUrl) {

  var timer = `<div id="eventTimerText">Event is due in:</div>
                    <div class="countdown mt-4" id="countdown">
                      <ul>
                        <li><span id="hours">00</span>Hrs</li>
                        <li><span id="minutes">00</span>Mins</li>
                        <li><span id="seconds">00</span>Secs</li>
                      </ul>
                </div>`;
  

  var modal = `<div class="modal fade" id="timerWarning" tabindex="-1" role="dialog">
		<div class="modal-dialog">
		  <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
          <span aria-hidden="true">&times;</span>
          <span class="sr-only">{{> i18n term="_close"}}</span>
          </button>
          <h4 class="modal-title"><span>Warning!</span></h4>
        </div>
        <div class="modal-body" id="timerWarningContent">
          <p>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary" data-dismiss="modal">OK</button>
        </div>
        </div>
      </div>
	  </div>`;

    var extractDate = function(prefix, html, regex) {
      var matches = regex.exec(html);
      if (matches) {
        var year = parseInt(matches[1]);
        var month = parseInt(matches[2]);
        var day = parseInt(matches[3]);
        var hour = parseInt(matches[4]);
        var minute = parseInt(matches[5]);
        var second = parseInt(matches[6]);
        return new Date(year, month, day, hour, minute, second);
      }
    };

  function startCountdown() {

    var config = {
      targetUrl: eventTimerUrl,
      followProposedTemplate: false,
      showLoading: false,
      manualRequestObj: [
        {
          Lbl: 'body',
          Src: 'body',
          Data: 'html'
        },
        {
          Lbl: 'span',
          Src: 'body > span',
          Data: 'text'
        }
      ],
      callback: function(data) {

        var html = data.CaptureResults.body[0].Properties.html;
        var endDate = extractDate(
          'count',
          html,
          /count[0-9]+\s*= new Date\(([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+),\s*([0-9]+)\s*\)/
        );
        if(!endDate){
          var $html = $($.parseHTML(html));
          $('[data-if-label="expireDateIframe"]').text($html.text());
          return;
        }
        $('.timer-container').html(timer);
        $('.whiteback').append(modal);

        //give timer a second to calculate time so it doesn't show 00:00:00
        setTimeout(function() {
          $('.timer-container').removeClass('hidden');
        }, 1000)

        interval = setInterval(function() {
          var now = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"})).getTime();
          var between = endDate.getTime() - now;

          var hours = Math.floor((between % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((between % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((between % (1000 * 60)) / 1000);

          if(hours === 0 && minutes === 1 && seconds === 0) {
            $('#timerWarningContent').html('<p>There is 1 minute remaining. Please be advised, once the timer expires you will not be able to submit your bid</p>')
            $('#timerWarning').modal('show');
          }

          if(hours === 0 && minutes === 5 && seconds === 0) {
            $('#timerWarningContent').html('<p>There is 5 minutes remaining. Please be advised, once the timer expires you will not be able to submit your bid</p>')
            $('#timerWarning').modal('show');
          }

          if(hours === 0 && minutes === 10 && seconds === 0) {
            $('#timerWarningContent').html('<p>There is 10 minutes remaining. Please be advised, once the timer expires you will not be able to submit your bid</p>')
            $('#timerWarning').modal('show');
          }

          if(hours === 0 && minutes === 30 && seconds === 0) {
            $('#timerWarningContent').html('<p>There is 30 minutes remaining. Please be advised, once the timer expires you will not be able to submit your bid</p>')
            $('#timerWarning').modal('show');
          }

          if(hours === 1 && minutes === 0 && seconds === 0) {
            $('#timerWarningContent').html('<p>There is 1 hour remaining. Please be advised, once the timer expires you will not be able to submit your bid</p>')
            $('#timerWarning').modal('show');
          }
    
          $("#hours").text(hours.toString().padStart(2, '0'));
          $("#minutes").text(minutes.toString().padStart(2, '0'));
          $("#seconds").text(seconds.toString().padStart(2, '0'));
          
          $('.timer-container').removeClass('hidden');

          var $eventStatus = $('[data-if-label="expireDateIframe"]');

          $eventStatus.text(`Due in ${hours.toString().padStart(2, '0')}hrs,${minutes.toString().padStart(2, '0')}mins,${seconds.toString().padStart(2, '0')}secs`)
          $eventStatus.addClass('text-danger');
    
          if(between < 0) {
            $('.timer-container').addClass('hidden');
            $('[data-if-label="expireDateIframe"]').text('Event Completed');
          }
        }, 1000);
      }
    }

    var InFlightPSHelper = new InFlightDCType();
    InFlightPSHelper.init(config);
  };



  startCountdown();


}